import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { Row } from 'ui/Flex';
import { useCapturedAmountTotal } from './hooks/useCapturedAmountTotal';
import { PepperTransactionsFilter } from './hooks/usePepperTransactionsFilter';
import { FormattedCapturedAmountTotal } from './hooks/capturedAmountTotal';

interface CapturedAmountTotalProps {
    filter: PepperTransactionsFilter;
}

const CapturedAmountTotalValue: React.FC<{
    totals: FormattedCapturedAmountTotal[];
    loading: boolean;
    error: boolean;
}> = ({ totals, loading, error }) => {
    if (loading) {
        return <CircularProgress size={16} />;
    }
    if (error) {
        return (
            <Typography variant="body2" color="error">
                Could not load the total
            </Typography>
        );
    }
    return (
        <>
            {totals.map(total => (
                <Typography key={total.currency} variant="body2" paddingLeft={1}>
                    {total.formatted}
                </Typography>
            ))}
        </>
    );
};

export const CapturedAmountTotal: React.FC<CapturedAmountTotalProps> = ({ filter }) => {
    const { totals, loading, error } = useCapturedAmountTotal(filter);
    return (
        <Row valign="center" align="flex-end">
            <Typography variant="body2" color="textSecondary">
                Total Captured Amount:
            </Typography>
            <Box paddingLeft={1} display="flex" alignItems="center">
                <CapturedAmountTotalValue totals={totals} loading={loading} error={error} />
            </Box>
        </Row>
    );
};
